export const environment = {
  production: true,
  
  apiUrl: "https://umyoauthor.site/api_umyocards/public/api/"
};


